// todo implement me
export const useFiles = () => ({
    saveToCSVFile: () => {},
    saveCurrentScan: () => {},
    readSavedScans: () => Promise.resolve([]),
    markScanAsShared: () => {},
    deleteScan: () => {}
})
